export default "__VITE_ASSET__369a7bb7__"